<template>
  <div>
    <chart-card :chart-data="data"
                :chart-options="options"
                :responsive-options="responsiveOptions"
                :render="render">
      <template slot="header">
        <h4 class="card-title">Evolution over time</h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend row ml-0">
          <span v-for="company in companies" :key="company.id">
            <i :class="'fas fa-circle ct-legend-'+company.color"/>
            {{company.profile.companyName}}
            &nbsp;
          </span>
        </div>
        <hr>
        <div class="stats">
          <i class="far fa-clock"/> {{subtitle}}
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Leads-Graph-Multi-View-Card',
  components: {
    ChartCard
  },
  props: {
    render: {type: Boolean, default: false},
    show:   {type: String, required: true}
  },
  data () {
    return {
      options: {
        //low: 0,
        //high: 1510,
        showArea: false,
        height: '245px',
        axisX: {
          showGrid: false
        },
        lineSmooth: true,
        showLine: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          right: 50
        }
      },
      responsiveOptions: [
        ['screen and (max-width: 640px)', {
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0]
            }
          }
        }]
      ]
    }
  },
  computed: {
    periodSelected () {
      return this.$store.getters.periodSelected
    },
    companies () {
      return this.$store.getters.companies.filter(c => !c.archived)
    },
    subtitle () {
      if (this.periodSelected) {
        return this.$store.getters.periodEvolution.label
      }
      return ''
    },
    lineChart () {
      if (this.$store.getters.leadsEvolution && this.$store.getters.leadsEvolution.lineCharts) {
        switch (this.show) {
          case 'Received':
            return this.$store.getters.leadsEvolution.lineCharts.received
          case 'Closed':
            return this.$store.getters.leadsEvolution.lineCharts.closed
            break
          case 'Close Rate':
            return this.$store.getters.leadsEvolution.lineCharts.closeRate
            break
          default:
            console.log('!!! LeadsGraphNuliViewCard.vue > lineChart(): default case, issue with show prop: ', this.show)
            return {}
            break;
        }
      }
      else {
        return {}
      }
    },
    data () {
      return this.lineChart.data
    },/* 
    options () {
      return this.lineChart.options
    },
    responsiveOptions () {
      return this.lineChart.responsiveOptions
    } */
  }
}
</script>

<style>

</style>